import { createSlice } from "@reduxjs/toolkit";
import { APP_EXTRACT } from "../Constant";
import { Reducer } from "./Reducer";
import { InitialState } from "./Types";

const initialState: InitialState = {
  appKey: APP_EXTRACT,
  tabList: [],
  threshold: 0
};

export const Slice = createSlice({
  initialState,
  name: "app-config",
  reducers: Reducer,
});
